// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__XAxy9","title":"Images45_title__UiUND","images":"Images45_images__3CLpt"};